<template>
    <a-layout>
        <cSider />
        <a-layout>
            <!-- <a-alert type="error" banner closable>
                <template slot="message">
                    <span>
                        {{ settingValid ? '设置异常' : '设置错误' }}，影响部分功能使用，
                        <router-link :to="{ path: '/setting' }">点击这里</router-link>
                        重新配置。
                    </span>
                </template>
            </a-alert> -->
            <a-alert type="warning" banner closable v-if="code === 1000">
                <template slot="message">
                    <span> 账号已到期，请<a href="javascript:;">联系客服</a>。 </span>
                </template>
            </a-alert>
            <cHeader />
            <router-view />
            <cFooter></cFooter>
        </a-layout>
    </a-layout>
</template>

<script>
import api from '@/apis';
import { mapState } from 'vuex';
import cHeader from '@/components/common/c_header';
import cSider from '@/components/common/c_sider';
import cFooter from '@/components/common/c_footer';
export default {
    components: {
        cHeader,
        cSider,
        cFooter
    },
    computed: {
        ...mapState({
            code: (state) => state.code
        })
    }
};
</script>
